{
	"dashboard": "Dashboard",
	"recoveryContainer": {
		"footerText": "© 2026 Zig The Global Funtech. All rights reserved."
	},
	"newLogin": {
		"heroTitle": {
			"prefix": "Zig organizes",
			"suffix": "the rhythm of your",
			"words": ["show", "event", "festival", "pub", "experience"]
		},
		"labels": {
			"company": "Organization",
			"login": "Login",
			"password": "Password"
		},
		"description": "To access, please fill in the data",
		"fields": {
			"organization": {
				"placeholder": "Enter the organization's name",
				"required": "The organization's name is required"
			},
			"username": {
				"placeholder": "Enter your username",
				"required": "Your username is required"
			},
			"password": {
				"placeholder": "Enter your password",
				"required": "Your password is required"
			}
		},
		"submit": "Enter",
		"forgotPassword": {
			"question": "Forgot your password?",
			"action": "Click here"
		}
	}
}
